<template>
  <div className="animated">
    <b-row class="my-2">
      <b-col>
        <h1 class="text-uppercase font-weight-bold">Listado de Inspecciones Procesos por Lote</h1>
      </b-col>
    </b-row>
    <server-filterable-table
      :downloadeable="false"
      :column_display="column_display"
      :columns="columns"
      :filterable="filterable"
      :headings="headings"
      :listColumns="listColumns"
      :url="url"
      :clickable="true"
      :action-buttons="action_buttons"
      @on-loading="loading = $event"
      @on-link-action="goToExternalLink"
      @on-download-action="downloadPDF"
      @on-send-action="emailPDF"
    >
    </server-filterable-table>
  </div>
</template>

<script>
import ServerFilterableTable from "@/bagno_views/ServerFilterableTable";
export default {
  name: "InspectionList",
  components: {
    ServerFilterableTable
  },
  data() {
    return {
      items: [],
      selectedItems: [],
      url: "/api/qc/lotqc/lotqc_process/",
      title: "Listado de Inspecciones",
      loading: false,
      action_buttons: ["download"],
      columns: ["lot_id", "lot__number", "q_lotqc", "process_number", "last_clasification", "actions"],
      filterable: [
        "name",
        "data.PCT_Grower",
        "data.PCT_Variety",
        "data._L_Name_Product",
        "pallet_number",
        "external_id"
      ],
      headings: {
        lot_id: "id",
        actions: "Acciones",
        lot__number: "Lote",
        q_lotqc: "Inspecciones",
        process_number: "numero de proceso",
        created_at: "Fecha inspección",
        clasification: "Nota final",
        pallet_number: "Pallet",
        "data.PCT_Grower": "Productor",
        "data.PCT_Variety": "Variedad",
        "data._L_Name_Product": "Tipo"
      },
      listColumns: {}
    };
  },
  methods: {
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    goToExternalLink(item) {
      window.open(item.data._L_Link_Web, "_blank");
    },
    async sendEmail(filename, recipientEmail, attachmentBlob) {
      try {
        const formData = new FormData();
        formData.append("to", recipientEmail);
        formData.append("subject", `Adjunto: ${filename}`);
        formData.append("body", "Adjunto encontrarás el PDF.");
        formData.append("attachment", new File([attachmentBlob], filename));

        // Asegúrate de que esta línea tenga la palabra clave 'await'
        await this.$axios.post("/api/v1/send-email", formData);

        alert("Correo electrónico enviado con éxito.");
      } catch (error) {
        console.error("Error al enviar el correo electrónico:", error);
        alert("Hubo un error al enviar el correo electrónico.");
      }
    },

    async downloadPDF(eve) {
      this.loading = true;
      try {
        const res = await this.$axios.get(`/api/v1/qc/download_process_pdf/${eve.process_number}/${eve.lot__number}`, {
          responseType: "arraybuffer"
        });
        this.forceFileDownload(res, `Inspeccion Lote ${eve.lot__number} Proceso ${eve.process_number}.pdf`);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
